import { useContext } from "react";
import { UserContext } from "./userContext";
import { FREE_TRIAL_DURATION } from "../../constants/membership";

const useFreeTrialDuration = () => {
  const user = useContext(UserContext);

  if (!user) return FREE_TRIAL_DURATION;

  return user.freeTrialDuration;
};

export { useFreeTrialDuration };
